import AboutSectionImage from '../../../assets/about/about-section-4.png';
import DownloadApp from '../../../components/downloadApp/DownloadApp';
import ScrollInAnimationItem from '../../../components/scrollInAnimationItem/ScrollInAnimationItem';
import { StorePlatform } from '../../../enums/store-platform.enum';
import AboutTextBox from '../aboutTextBox/AboutTextBox';

import styles from './AboutPlayersSection.module.scss';

const AboutPlayersSection = ({ mainAnimationLoaded }: { mainAnimationLoaded: boolean }) => {
  return (
    <div className={styles['section']}>
      <div className={styles['content']}>
        <ScrollInAnimationItem className={styles['textbox-container']} delay="0.2s" threshold={0.3}>
          <AboutTextBox
            dark
            className={styles['textbox']}
            caption={
              <>
                from <b>millions</b> of players
              </>
            }
            content={
              <>
                <p>
                  The first game introduced to the ecosystem and a flagship property associated with the Reality
                  Metaverse is a mobile game called Landlord GO. With over 6 million active players and 21 million
                  Landlord Games downloads, Landlord GO is the most recognizable geo-location property trading game
                  globally. Landlord GO is a first-in-class business simulator game using real-life properties from
                  around the globe. Unlike other board games, the game draws real data from real buildings, real people
                  and sets actual prices associated with each property.
                </p>
              </>
            }
          />
        </ScrollInAnimationItem>
        <ScrollInAnimationItem className={styles['section-image-container']} delay="0.1s">
          <img
            alt=""
            className={styles['section-image']}
            src={mainAnimationLoaded ? AboutSectionImage : ''}
            width="761"
            height="462"
          />
          <div className={styles['stores']}>
            <DownloadApp className={styles['stores__download']} platform={StorePlatform.googlePlatform}></DownloadApp>
            <DownloadApp className={styles['stores__download']} platform={StorePlatform.appleStore}></DownloadApp>
          </div>
        </ScrollInAnimationItem>
      </div>
    </div>
  );
};

export default AboutPlayersSection;
